import React from 'react';
import PropTypes from 'prop-types';
import Date from "components/Display/ViewDate";
import Amount from "components/Display/Amount";
import TransactionKey from "../Display/TransactionKey";



const PaymentSettingTable = ({ data }) => {
  if (!data.payments){
    return (
      <div/>
    );
  }

  let payments = data.payments;
  return (
      <div className="calc-setting-table ">
        <table className="table">
          <colgroup>
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th colSpan="4" className="text-left calc-setting-table-header">Innborganir/afslættir/niðurfellingar</th>
          </tr>
          <tr>
            <th className="text-left">Færslulykill</th>
            <th className="text-right">Dagsetning</th>
            <th className="text-right">Til kröfuhafa</th>
            <th className="text-right">Til lögmanns</th>
          </tr>
          </thead>
          <tbody>
          {payments.map(function(item,i){
            return(
            <tr key={i}>
              <td className="text-left"><TransactionKey data={item.transactionKey}/></td>
              <td className="text-right"><Date data={item.paymentDate}/></td>
              <td className="text-right"><Amount data={item.amount}/></td>
              <td className="text-right"><Amount data={item.lawyerAmount}/></td>
            </tr>);
          })}
          </tbody>
        </table>
      </div>
  );
};

PaymentSettingTable.propTypes = {
  data: PropTypes.object,
};

export default PaymentSettingTable;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Settings/PaymentSettingTable.js